//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {queryEmail} from '@/api/index'
import {deleteEmail} from '@/api/index'

export default {
    data() {
        return {
            list: null
        }
    },
    mounted() {
        this.$vux.loading.show({
            text: '加载中...'
        });
        this.getList();
    },
    methods: {
        //查询邮箱接口封装
        getList() {
            //查询邮箱接口
            queryEmail().then(res => {
                this.$vux.loading.hide();
                if (res.data.code === 0) {
                    this.list = res.data.data.arrayList;
                } else {
                    this.$vux.toast.text(res.data.msg, 'middle');
                }
            })
        },
        //删除邮箱
        deleteItem(id) {
            //删除邮箱接口
            deleteEmail({
                id
            }).then(res => {
                if (res.data.code === 0) {
                    //删除邮箱以后重新调用查询邮箱接口重新渲染页面
                    this.getList();
                } else {
                    this.$vux.toast.text(res.data.msg, 'middle');
                }
            })
        },
        //编辑邮箱（带数据跳转到addEmail）
        changeItem(data) {
            this.$router.push({
                path: '/addEmail',
                query: {
                    data
                }
            })
        },
        //发送邮件的几个页面跳转过来选择邮箱
        select_back(item) {
            let t = this;
            if (t.from !== '/addEmail') {
                t.$store.commit('RECORD_EMAIL', item);
                t.$router.go(-1);
            }
        },
        //新增邮箱（跳转到addEmail）
        addEmail() {
            this.$router.push('/addEmail');
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/email/selectEmail.vue